import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-redeem-rewards-failure-popup',
    templateUrl: './redeem-rewards-failure-popup.component.html',
    styleUrls: ['./redeem-rewards-failure-popup.component.scss'],
    standalone: false
})
export class RedeemRewardsFailurePopupComponent implements OnInit {

  @Input()
  data: any = {};

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  redirectToLogin() {
    this.router.navigate([ 'login' ]);
  }
}
